import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Hub from "@/pages/Hub";
import ArticlePage from "@/pages/ArticlePage";
import Toolkits from "@/pages/Toolkits";
import Book from "@/pages/Book";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Insights from "@/pages/Insights";
import Contact from "@/pages/Contact";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import Library from "@/pages/Library";
import ChatWidget from "@/components/ChatWidget";
import RuralHome from "@/pages/RuralHome";
import RuralOpportunity from "@/pages/RuralOpportunity";
import RuralAgritourism from "@/pages/RuralAgritourism";
import RuralHipcamp from "@/pages/RuralHipcamp";
import RuralProtect from "@/pages/RuralProtect";
import RuralExplorer from "@/pages/RuralExplorer";
import RuralChecklist from "@/pages/RuralChecklist";
import RuralEstimator from "@/pages/RuralEstimator";
import RuralGuestPack from "@/pages/RuralGuestPack";
import RuralResources from "@/pages/RuralResources";
import DaService from "@/pages/DaService";
import DaUpload from "@/pages/DaUpload";
import DaReport from "@/pages/DaReport";
import AudiencePage from "@/pages/AudiencePage";
import LegalPage from "@/pages/LegalPage";
import ProductPage from "@/pages/ProductPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-ivory text-charcoal font-sans flex flex-col">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hub" element={<Hub />} />
            <Route path="/hub/:slug" element={<ArticlePage />} />
            <Route path="/rural" element={<RuralHome />} />
            <Route path="/rural/opportunities/:slug" element={<RuralOpportunity />} />
            <Route path="/rural/agritourism" element={<RuralAgritourism />} />
            <Route path="/rural/hipcamp" element={<RuralHipcamp />} />
            <Route path="/rural/protect" element={<RuralProtect />} />
            <Route path="/rural/explorer" element={<RuralExplorer />} />
            <Route path="/rural/checklist" element={<RuralChecklist />} />
            <Route path="/rural/estimator" element={<RuralEstimator />} />
            <Route path="/rural/guest-pack" element={<RuralGuestPack />} />
            <Route path="/rural/resources" element={<RuralResources />} />
            <Route path="/da-approved" element={<DaService />} />
            <Route path="/da-approved/upload" element={<DaUpload />} />
            <Route path="/da-approved/report/:id" element={<DaReport />} />
            <Route path="/start/:slug" element={<AudiencePage />} />
            <Route path="/toolkits" element={<Toolkits />} />
            <Route path="/toolkits/:id" element={<ProductPage />} />
            <Route path="/book" element={<Book />} />
            <Route path="/planner-connect" element={<Book />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/legal/:slug" element={<LegalPage />} />
            <Route path="/library/:key" element={<Library />} />
          </Routes>
        </main>
        <Footer />
        <ChatWidget />
        <Toaster position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
